const AgentsTableColumns = [
    // {
    //     id: "id",
    //     labelAr: "المعرف",
    //     labelEn: "ID",
    //     sortable: true,
    // },
    {
        id: "name",
        labelAr: "الاسم",
        labelEn: "Name",
        sortable: true,
    },
    {
        id: "country",
        labelAr: "الدولة",
        labelEn: "Country",
        sortable: true,
    },
    {
        id: "sales_person",
        labelAr: "مسؤول المبيعات",
        labelEn: "Sales Person",
        sortable: false,
    },
    {
        id: "license_number",
        labelAr: "رقم الترخيص",
        labelEn: "License",
        sortable: true,
    },
    {
        id: "email",
        labelAr: "البريد الإلكتروني",
        labelEn: "Email",
        sortable: true,
    },
    {
        id: "phone",
        labelAr: "رقم الهاتف",
        labelEn: "Phone",
        sortable: true,
    },
    {
        id: "term_of_payment",
        labelAr: "طريقة الدفع",
        labelEn: "Term of Payment",
        sortable: true,
    },
    {
        id: "programs_count",
        labelAr: "عدد البرامج",
        labelEn: "Programs Count",
        sortable: false,
    },
    {
        id: "status",
        labelAr: "الحالة",
        labelEn: "Status",
        sortable: true,
    },
    // {
    //     id: "actions",
    //     labelAr: "الإجراءات",
    //     labelEn: "Actions",
    //     align: "right",
    //     sortable: false,
    // },
];

export default AgentsTableColumns;
